// Mobilde giriş kutusuna dokunulduğunda tarayıcı sayfayı yakınlaştırır ve
// oyuncu küçültmek için iki parmakla sıkıştırmak zorunda kalır; çoğu oyuncu
// bunu anlamaz. Kilit şemanın bayrağıdır (`siteThemes.js` → `lockViewport`,
// bugün yalnızca özel bir şemada) ve iki yerden uygulanır:
//
// * **İlk boyamada** `public/index.html`'deki betik son bilinen kararı
//   `VIEWPORT_LOCK_CACHE_KEY`'den okuyup meta etiketini yazar. React
//   yüklendikten sonra yazılan bir viewport etiketi, o ana kadar dokunulan
//   bir alanın yakınlaştırmasını geri almaz — karar paketten önce bilinmelidir.
// * **Ayarlar geldiğinde ve sayfa değiştiğinde** karar yeniden hesaplanıp hem
//   etikete hem önbelleğe yazar; şema panelden değiştirildiğinde ya da ilk
//   ziyarette önbellek boşken kilit buradan gelir. Bu işi rotayı bilen
//   `components/ViewportLock.jsx` yapar: portaldan panele geçilince kilit kalkar.
//
// Yönetim paneli kilitlenmez: tablolar ve uzun formlar telefonda yakınlaştırma
// ister. Etiketin iki değeri de burada ve index.html'de aynı kalmalıdır.
import { getSiteTheme } from './siteThemes';
import { isPanelPath, portalVisible } from './adminDomain';

export const VIEWPORT_LOCK_CACHE_KEY = 'app:viewport-lock-v1';

export const VIEWPORT_DEFAULT = 'width=device-width, initial-scale=1, viewport-fit=cover';
export const VIEWPORT_LOCKED = (
  'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover'
);

/** Bu ayarlarla, bu adreste yakınlaştırma kilitlensin mi? */
export const viewportLocked = (settings, pathname) => Boolean(
  settings
  && getSiteTheme(settings.site_theme).lockViewport
  && portalVisible(settings)
  && !isPanelPath(settings, pathname),
);

export const applyViewportLock = (
  locked,
  doc = typeof document !== 'undefined' ? document : null,
) => {
  const meta = doc?.querySelector?.('meta[name="viewport"]');
  if (!meta) return false;
  const content = locked ? VIEWPORT_LOCKED : VIEWPORT_DEFAULT;
  // Aynı değeri yeniden yazmak bazı tarayıcılarda ölçeği sıfırlar.
  if (meta.getAttribute('content') !== content) meta.setAttribute('content', content);
  return true;
};

export const cacheViewportLock = (
  locked,
  storage = typeof window !== 'undefined' ? window.localStorage : null,
) => {
  try {
    if (locked) storage?.setItem(VIEWPORT_LOCK_CACHE_KEY, '1');
    else storage?.removeItem(VIEWPORT_LOCK_CACHE_KEY);
  } catch {
    // Depolama kapalıysa kilit yine ayarlar gelince uygulanır.
  }
};
